document.addEventListener("click", (event) => {
  document.querySelectorAll("details[data-close-on-outside-click][open]").forEach((details) => {
    if (!details.contains(event.target)) {
      details.removeAttribute("open")
    }
  })
})
